import { useRef, useEffect, useMemo, useCallback } from 'react'
import styled from 'styled-components'
import videojs from 'video.js'

import 'video.js/dist/video-js.css'
import { EMBED_TYPES } from '../data/constants'

export default function Video({ src, type }) {
  const videoRef  = useRef(null)
  const playerRef = useRef(null)

  const videoJsOptions = useMemo(() => ({
    autoplay: true,
    controls: true,
    responsive: true,
    fluid: true,
    aspectRatio: '16:9',
    sources: [{
      src
    }]
  }), [src])

  const onReady = useCallback((player) => {
    player.src(src)
    player.play()
  }, [src])

  useEffect(function() {
    if (!videoRef.current) return

    playerRef.current = videojs(videoRef.current, videoJsOptions, () => {
      videojs.log('player is ready');
      onReady && onReady(playerRef.current)
    })
  }, [src, videoJsOptions, onReady])

  switch(type) {
    case EMBED_TYPES.VIDEO_JS:
      return (
        <div data-vjs-player>
          <StyledVideo ref={videoRef} className='video-js vjs-big-play-centered' />
        </div>
      )

    case EMBED_TYPES.IMAGE:
      return (
        <StyledImg src={`${src}&t=${Date.now()}`} />
      )

    default: 
        return (
          <StyledIframe src={src} />
        )
  } 
}

const StyledVideo = styled.video`
  width: 100%;
  height: 100%;
`

const StyledIframe = styled.iframe`
  border: none;
  width: 100%;
  aspect-ratio: 16 / 9;
`

const StyledImg = styled.img`
  width: 100%;
  height: auto;
`
